import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { getUserRole } from '../../../../services/common/util';

const panelStyles = { overlay: { position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.3)', zIndex: 1040 }, panel: { position: 'fixed', top: 0, right: 0, width: '420px', height: '100vh', background: '#fff', boxShadow: '-4px 0 20px rgba(0,0,0,0.15)', zIndex: 1041, display: 'flex', flexDirection: 'column', overflowY: 'auto' }, header: { padding: '16px 20px', borderBottom: '1px solid #e0e0e0', display: 'flex', alignItems: 'center', justifyContent: 'space-between', background: '#f8f9fa' }, title: { margin: 0, fontSize: '16px', fontWeight: 600, color: '#333' }, body: { padding: '20px', flex: 1 }, section: { marginBottom: '20px' }, sectionTitle: { fontSize: '11px', fontWeight: 700, color: '#888', letterSpacing: '0.08em', textTransform: 'uppercase', marginBottom: '10px', paddingBottom: '6px', borderBottom: '1px solid #eee' }, dl: { display: 'grid', gridTemplateColumns: '150px 1fr', rowGap: '8px', margin: 0 }, dt: { fontSize: '13px', color: '#555', fontWeight: 600, paddingRight: '8px' }, dd: { fontSize: '13px', color: '#222', margin: 0 }, editBtn: { background: '#0066cc', color: '#fff', border: 'none', borderRadius: '4px', padding: '6px 14px', fontSize: '13px', cursor: 'pointer', marginRight: '8px' }, closeBtn: { background: 'transparent', border: 'none', fontSize: '18px', cursor: 'pointer', color: '#666' } };

export default class EditBtnCellRenderer extends Component {
    constructor(props) {
        super(props);
        this.state = { showPanel: false };
    }

    handleEdit = () => {
        this.props.context.componentParent.handleEdit(this.props.data);
    };

    handleDelete = () => {
        this.props.context.componentParent.handleDelete(this.props.data._id);
    };

    renderPanel() {
        const d = this.props.data;
        return ReactDOM.createPortal(
            <>
                <div style={panelStyles.overlay} onClick={() => this.setState({ showPanel: false })} />
                <div style={panelStyles.panel}>
                    <div style={panelStyles.header}>
                        <h5 style={panelStyles.title}>Reflex Rule Details</h5>
                        <div>
                            <button style={panelStyles.editBtn} onClick={() => { this.setState({ showPanel: false }); this.handleEdit(); }}><i className="fas fa-pen" style={{ marginRight: 5 }}></i>Edit</button>
                            <button style={panelStyles.closeBtn} onClick={() => this.setState({ showPanel: false })}><i className="fas fa-times"></i></button>
                        </div>
                    </div>
                    <div style={panelStyles.body}>
                        <div style={panelStyles.section}>
                            <div style={panelStyles.sectionTitle}>Rule Information</div>
                            <dl style={panelStyles.dl}>
                                <dt style={panelStyles.dt}>Name</dt><dd style={panelStyles.dd}>{d.name || '—'}</dd>
                                <dt style={panelStyles.dt}>Type</dt><dd style={panelStyles.dd}>{d.type || '—'}</dd>
                                <dt style={panelStyles.dt}>Test</dt><dd style={panelStyles.dd}>{(d.testId && d.testId.name) || d.testId || '—'}</dd>
                                <dt style={panelStyles.dt}>Trigger Test</dt><dd style={panelStyles.dd}>{(d.triggerTestId && d.triggerTestId.name) || d.triggerTestId || '—'}</dd>
                                <dt style={panelStyles.dt}>Status</dt><dd style={panelStyles.dd}>{d.status || '—'}</dd>
                                <dt style={panelStyles.dt}>Created By</dt><dd style={panelStyles.dd}>{d.createdBy || '—'}</dd>
                            </dl>
                        </div>
                        {d.description && <div style={panelStyles.section}><div style={panelStyles.sectionTitle}>Description</div><div style={{ fontSize: '13px', color: '#222' }}>{d.description}</div></div>}
                    </div>
                </div>
            </>,
            document.body
        );
    }

    renderTooltipEdit = (props) => (
        <Tooltip id="button-tooltip" {...props}>
            Edit Rule
        </Tooltip>
    );

    renderTooltipDelete = (props) => (
        <Tooltip id="button-tooltip" {...props}>
            Delete Rule
        </Tooltip>
    );

    render() {
        const canManage = getUserRole() && /superadmin|admin|labtech/.test(getUserRole().toLowerCase());

        if (!canManage) {
            return null;
        }

        return (
            <div>
                <OverlayTrigger placement="top" delay={{ show: 50, hide: 100 }} overlay={<Tooltip id="button-tooltip">View Rule</Tooltip>}>
                    <button onClick={() => this.setState({ showPanel: true })} style={{ border: 'none', backgroundColor: 'transparent' }}>
                        <i className="fas fa-eye"></i>
                    </button>
                </OverlayTrigger>
                {this.state.showPanel && this.renderPanel()}

                <OverlayTrigger placement="top" delay={{ show: 50, hide: 100 }} overlay={this.renderTooltipEdit}>
                    <button onClick={this.handleEdit} style={{ border: 'none', backgroundColor: 'transparent' }}>
                        <i className="fas fa-pen"></i>
                    </button>
                </OverlayTrigger>

                <OverlayTrigger placement="top" delay={{ show: 50, hide: 100 }} overlay={this.renderTooltipDelete}>
                    <button onClick={this.handleDelete} style={{ border: 'none', backgroundColor: 'transparent', marginLeft: '10px' }}>
                        <i className="fas fa-trash text-danger"></i>
                    </button>
                </OverlayTrigger>
            </div>
        );
    }
}
